const sliderTokens = ({ colors, sizes, space, fontSizeBody }) => ({
  colors: {
    line: colors.primary['50'],
    lineMoved: colors.neutral['40'],
    text: colors.neutral['90'],
    neutralBorder: colors.primary['50'],
    neutralBorderActive: colors.primary['50'],
    neutralBg: colors.primary['50'],
    brandPrimaryActive: colors.primary['50'],
  },
  sizes: {
    default: sizes[0],
    lg: sizes[0],
    defaultActive: sizes[2],
    lgActive: sizes[2],
    sliderRail: '2px',
    sliderTracked: '2px',
  },
  space: {
    textPositionTop: {
      default: space[5],
      lg: space[4],
    },
    stylesLabel: space[5],
  },
  fontSizes: fontSizeBody[1],
  transition: 'width 0.2s ease, height 0.2s ease',
});

export default sliderTokens;
